import React, { memo } from 'react';
import PropTypes from 'prop-types';

import ChevronRightIcon from 'static/images/chevron-right.svg';
import { useDispatch } from 'react-redux';
import { actionCreators } from 'react/api/actions/monitor';
import { Container } from './styles';

function RouteCardButton({ routeView }) {
  const dispatch = useDispatch();

  function handleOnClick() {
    dispatch(actionCreators.openRoutePanel({ route: routeView }));
  }

  return (
    <Container onClick={() => handleOnClick()} data-testid="card-button-panel">
      <img src={ChevronRightIcon} alt="Chevron Right Icon" />
    </Container>
  );
}

RouteCardButton.propTypes = {
  routeView: PropTypes.object.isRequired
};

export default memo(RouteCardButton);
